import { Car } from 'src/app/profile/_interfaces/car.model';

export const isCarValid = (car?: Car | undefined | null): boolean => {
  return !!(car?.color && car?.make && car?.model && car?.plate);
};
